import rupeeFormat from "components/Api/RupeeFormat";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import rupeees from "assets/img/rupees.png";
import daysNight from "assets/img/night-mode_9554519.jpg";
import include from "assets/img/Icon fa-solid-taxi.png";
import gypsy from "assets/img/newicon.png";
import camera from "assets/img/camera.png";
import hotel from "assets/img/Icon fa-solid-hotel.png";
import experiance from "assets/img/path.png";
import { useToast } from "provider/ToastProvider";
import { useAuth } from "provider/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import apiCall from "components/Api/api";
import { handleError } from "components/Api/handleError";
import { useState } from "react";
import { useScreenSize } from "provider/ScreenSizeProvider";
import { common } from "Data/common";

const { useSafariPackagesContext } = require("provider/SharePackagesProvider");

const PackageDetailCard = () => {
  const { safarioperator, packSlug } = useParams();
  const {isMobileView} = useScreenSize();
  const navigate = useNavigate();
  const { isLoggedIn, logout } = useAuth();
  const { showWarningToast } = useToast();
  const { packageViewData, safariPackagesDispatch } =
    useSafariPackagesContext();
  const [loadingWish, setLoadingWish] = useState();
  const fullUrl = `https://walkintothewild.in/package/${safarioperator}/${packSlug}`;
  const [partnerError, setPartnerError] = useState(false);

  // const handleOpenEnquery = () => {
  //   safariPackagesDispatch({
  //     type: "SET_PACKAGE_ENQURI_FORM_TOGGLE",
  //     payload: true,
  //   });
  // };

  const PACKAGE = common?.SAFARI_PACKAGE?.VIEW?.PACKAGE_CARD;

  const addInWishList = async () => {
    try {
      setLoadingWish(true);

      const response = await apiCall({
        url: `package/${packSlug}/wishlist`,
        method: "POST",
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;

      //check error after 200/ok
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        safariPackagesDispatch({
          type: "SET_PACKAGE_VIEW_ERROR",
          payload: apiData.errors,
        });
        console.error("API returned errors:", apiData.errors);
        return;
      }
      // updade shared sfari if status = 1
      if (apiData?.status === 1) {
        safariPackagesDispatch({
          type: "UPDATE_PACKAGE_VIEW_DETAILS",
          payload: {
            is_wishlist: true,
          },
        });
      } else {
        // Catch unexpected success payload with status ≠ 1
        console.warn("Unexpected API status:", apiData?.message);
        showWarningToast(apiData?.message);
      }
    } catch (error) {
      // Optionally dispatch network error

      handleError(error, logout, navigate);
    } finally {
      setLoadingWish(false);
    }
  };
  const removeFromWishList = async () => {
    try {
      setLoadingWish(true);

      const response = await apiCall({
        url: `package/${packSlug}/unwishlist`,
        method: "POST",
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;

      //check error after 200/ok
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        safariPackagesDispatch({
          type: "SET_PACKAGE_VIEW_ERROR",
          payload: apiData.errors,
        });
        console.error("API returned errors:", apiData.errors);
        return;
      }
      // updade shared sfari if status = 1
      if (apiData?.status === 1) {
        safariPackagesDispatch({
          type: "UPDATE_PACKAGE_VIEW_DETAILS",
          payload: {
            is_wishlist: false,
          },
        });
      } else {
        // Catch unexpected success payload with status ≠ 1
        console.warn("Unexpected API status:", apiData?.message);
      }
    } catch (error) {
      // Optionally dispatch network error

      handleError(error, logout, navigate);
    } finally {
      setLoadingWish(false);
    }
  };

  const copyToClipboard = async (link) => {
    try {
      await navigator.clipboard.writeText(link);
      showWarningToast("Link Copied");
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };
  return (
    <>
      <Row className=" border_bottom2 pb-4">
        <Col lg={8} md={12} sm={12} sx={12}  className={isMobileView ? '' : 'border-right'}>
          <Row className="h-100">
            <Col sm={12} md={12} lg={3} xs={12} className="maxWidth pb-md-3 pb-lg-0">
              <div className="images_tour select_safrai ">
                {/* <img

                  src={
                    partnerError || !packageViewData?.partner?.image_path
                      ? "/img/placeholder.jpg"
                      : packageViewData.partner.image_path
                  }
                  className="w-100 h-100"
                  alt="Partner"
                  onError={() => setPartnerError(true)}
                /> */}
                 <img

                  src={
                    partnerError || !packageViewData?.image_path
                      ? "/img/placeholder.jpg"
                      : packageViewData?.image_path
                  }
                  className="w-100 h-100"
                  alt="Partner"
                  onError={() => setPartnerError(true)}
                /> 
              </div>
            </Col>
            <Col
              lg={8}
              md={9}
              className="d-flex flex-column "
            >
              <div className="safrititles ">
                <div className="m-0 lh-1 d-inline font-devator">
                  {packageViewData?.package_display_name}{" "}
                </div>

                {isLoggedIn && (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip style={{ position: "fixed" }}>
                        {packageViewData?.is_wishlist
                          ? "Remove from watchlist"
                          : "Add to watchlist"}
                      </Tooltip>
                    }
                  >
                    {packageViewData?.is_wishlist ? (
                      <FontAwesomeIcon
                        icon={faHeartSolid}
                        size="xl"
                        style={{ cursor: "pointer", color: "red" }}
                        onClick={removeFromWishList}
                        disabled={loadingWish}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faHeartRegular}
                        size="xl"
                        style={{ cursor: "pointer" }}
                        onClick={addInWishList}
                        disabled={loadingWish}
                      />
                    )}
                  </OverlayTrigger>
                )}

                <h6 className="titler_safari">
                  <Link to={`/park/${packageViewData?.primary_park_slug}`}>
                    <i className="fa-solid fa-location-dot me-1"></i>{" "}
                    {packageViewData?.primary_park}
                  </Link>
                </h6>
                <p className="mb-0 ">
                  {PACKAGE?.ORGANIZED_BY}{" "}
                  <Link
                    to={`/operator/${packageViewData?.partner?.slug}/profile`}
                  >
                    <strong>{packageViewData?.partner?.business_name}</strong>
                  </Link>
                </p>
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={4} className="d-md-block d-lg-none d-none">
          <div className="text-left">
            <div className="pakageCost ">
              <h6 className="fs-4 mb-0 fw-bold ">
                <img src={rupeees} alt="" width="20px" className="me-1 mb-1" />
                {packageViewData?.total_price} /
                <span className="perpersonText">{PACKAGE?.COST_PER_PERSON}</span>
              </h6>
            </div>
            <div className="btn_wrap float-lg-end pt-lg-0 pt-3">
              <div className="message">
                {/* <Link
                  to="#"
                  className="packageBtn d-block w-100 text-center"
                  onClick={handleOpenEnquery}
                >
                  Book Now
                </Link> */}
              </div>
            </div>
          </div>
        </Col>
        <Col lg={4} className="pt-lg-0 pt-4">
          <Row className="ps-1">
            <Col xs={12} sm={6} className="  mb-3">
              <div className="safridetails_form d-flex gap-3 ">
                <div className="iconImg">
                  <img
                    src={daysNight}
                    alt=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-title="Trip Duration"
                  />
                </div>
                <div className="text-form">
                  <span class="mark_area">{PACKAGE?.TRIP_DURATION}</span>
                  <p className="mb-0">
                    {packageViewData?.no_of_night} {PACKAGE?.NIGHTS} ,{" "}
                    {packageViewData?.no_of_day} {PACKAGE?.DAYS}
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} className="mb-3">
              <div className="safridetails_form d-flex gap-3 ">
                <div className="iconImg">
                  <img
                    src={include}
                    alt=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-title="Pick & Drop"
                  />
                </div>
                <div className="text-form">
                  <span class="mark_area">{PACKAGE?.PICK_DROP}</span>
                  <p className="mb-0">
                    {packageViewData?.pick_and_drop_display}
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} className="mb-3">
              <div className="safridetails_form d-flex gap-3 ">
                <div className="iconImg">
                  <img
                    src={gypsy}
                    alt=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-title="Safaris"
                  />
                </div>
                <div className="text-form">
                  <span class="mark_area">{PACKAGE?.SAFARIS}</span>
                  <p className="mb-0">
                    {packageViewData?.no_of_safari} {packageViewData?.safari_type === 1 ? 'Shared Safari'  : 'Private Safari'}
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} className="mb-3">
              <div className="safridetails_form d-flex gap-3 ">
                <div className="iconImg">
                  <img
                    src={experiance}
                    alt=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-title="Meals"
                  />
                </div>
                <div className="text-form">
                  <span class="mark_area">{PACKAGE?.MEAL}</span>
                  <p className="mb-0">{packageViewData?.meals}</p>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} className="mb-3">
              <div className="safridetails_form d-flex gap-3 ">
                <div className="iconImg">
                  <img
                    src={camera}
                    alt=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-title="Theme"
                  />
                </div>
                <div className="text-form">
                  <span class="mark_area">{PACKAGE?.THEME}</span>
                  <p className="mb-0">{PACKAGE?.PHOTO_APISE}</p>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} className="mb-3">
              <div className="safridetails_form d-flex gap-3">
                <div className="iconImg">
                  <img
                    src={hotel}
                    alt=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-title="Accommodation"
                  />
                </div>
                <div className="text-form">
                  <span class="mark_area">{PACKAGE?.ACCOMMODATION}</span>

                  <p className="mb-0">
                    {packageViewData?.package_range?.title || "N/A"}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="pt-md-4 align-items-center gx-4 border_bottom2 pb-4">
        <Col lg={8} className="">
          <div className="social-share d-flex  flex-wrap gap-2 align-items-center justify-content-lg-start justify-content-between  ">
            <p>{PACKAGE?.PACKAGE_TEXT}:</p>
            <div className="sociel_icons ps-xl-3">
              <ul>
                <ul className="list-unstyled d-flex gap-2">
                  <li>
                    <Link
                       to={`https://www.facebook.com/sharer/sharer.php?u=${fullUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="iconSize"
                    >
                      <i className="fa-brands fa-facebook-f"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                        to={`https://twitter.com/intent/tweet?url=${fullUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="iconSize"
                    >
                      <i className="fa-brands fa-x-twitter"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                        to={`https://www.instagram.com/?url=${fullUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="iconSize"
                    >
                      <i className="fa-brands fa-instagram"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                        to={`https://wa.me/?text=${fullUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="iconSize"
                    >
                      <i className="fa-brands fa-whatsapp"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                        to={`https://www.linkedin.com/shareArticle?mini=true&url=${fullUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="iconSize"
                    >
                      <i className="fa-brands fa-linkedin-in"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                        to={`https://telegram.me/share/url?url=${fullUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="iconSize"
                    >
                      <i className="fa-solid fa-paper-plane pe-1"></i>
                    </Link>
                  </li>
                  <li>
                    <span
                      className="iconSize copytoclipboard"
                      onClick={() => {
                        copyToClipboard(fullUrl);
                      }}
                      data-href={`${fullUrl}`}
                    >
                      <i className="fa-solid fa-link"></i>
                    </span>
                  </li>
                </ul>
              </ul>
            </div>
          </div>
        </Col>
        <Col lg={4} className="d-lg-block  mobile_didplay_block">
          <div className="d-flex justify-content-md-end align-items-center flex-wrap pt-lg-0 pt-sm-3 pt-3">
            <div className="pakageCost mb-xxl-0 mb-2">
              <h6 className="fs-4 mb-0 fw-bold">
                <img src={rupeees} alt="" width="20px" className="me-1 mb-1" />
                {rupeeFormat(packageViewData?.total_price)} /{" "}
                <span className="perpersonText">{PACKAGE?.COST_PER_PERSON}</span>
                {/* <span className="perpersonText">Per Person</span> */}
              </h6>
            </div>
            <div className="btn_wrap float-lg-end pt-sm-3 pt-lg-0">
              <div className="message">
                {/* <Link
                  to="#"
                  className="packageBtn d-block w-100 text-center"
                  onClick={handleOpenEnquery}
                >
                  Book Now
                </Link> */}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default PackageDetailCard;
